import type { MiniGamePageConfig } from '@/app/(football)/[team]/mini-game/_context/types';

export const fcseoulConfig: MiniGamePageConfig = {
  game: {
    colors: ['#e8e700', '#ce0000', '#120200', '#ffffff'],
    background: {
      color: '#ebebeb',
    },
  },
  titleImage: {
    width: 180,
    height: 80,
    alt: 'FC서울 미니게임 타이틀',
    marginTop: 54,
  },
  eventPeriod: {
    endDate: '2026-12-31T23:59:59+09:00',
  },
};
